// extracted by mini-css-extract-plugin
export default {"right":"styles_right__GI9s-","copyright":"styles_copyright__p92El","social":"styles_social__2GZJ0"};